import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sample-size-calculator',
  component: () => import('../../routes/SampleSizeCalculator.svelte'),
  card: {
    id: 'sample-size-calculator',
    title: 'Sample Size Calculator',
    description: 'Determine how many survey responses or data points you need for reliable results. Plan your research with confidence using proven statistical formulas.',
    icon: 'groups',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/sample-size-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Sample Size Calculator – Find the Right Survey Sample Size',
    description: 'Free sample size calculator. Calculate how many respondents you need for your survey or study using confidence level, margin of error, and population size.',
  },
};

export default meta;